<template>
    <div class="file-content-wrap">
      <div class="pdf-content" v-if="isPdf">
        <pdf class="pdf-content" v-for="i in numPages" :key="i" :page="i" :src="curFileSrc" />
      </div>
       <!-- <object :data="curFileSrc" type="application/pdf" width="100%" height="100%"></object> -->
       <img v-else class="file-content" :src="curFileSrc" />
    </div>
</template>

<script>
  import pdf from 'vue-pdf'
  export default {
    name: "ViewPDf",
    props: {
      fileSrc: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
        pdfWorker: null,
        curFileSrc: '',
        numPages: 0,
        isPdf: true,
      }
    },
    created() {
      this.curFileSrc = decodeURIComponent(this.fileSrc || this.$route.query.url);
      this.isPdf = this.curFileSrc.endsWith('.pdf');
      console.log('+++++++++++++++++ this.curFileSrc +++++++++++++++++', this.curFileSrc, this.isPdf);
      const fileName = this.getFileName(this.curFileSrc);
      console.log('+++++++++++++++++ fileName +++++++++++++++++', fileName);
      fileName && !this.fileSrc && (document.title = fileName);
      if(this.isPdf) {
        try {
          this.pdfWorker = pdf.createLoadingTask(this.curFileSrc)
          pdf.createLoadingTask(this.curFileSrc)
          console.log(this.pdfWorker,'11111111',this.curFileSrc)
          this.pdfWorker.promise.then(pdf => {
              console.log(pdf)
              this.numPages = pdf.numPages;
          })
          .catch(err=>console.info(err));
        } catch (error) {
            console.info(error);
        }
      }
    },
    components: {
        pdf,
    },
    methods: {
        destroyWorker() {
            this.pdfWorker._worker && this.pdfWorker._worker.destroy();
        },
    }
  }
</script>

<style lang="scss" scoped>
.file-content-wrap {
  width: 100%;
  height: 100%;
  min-height: 300px;
  .pdf-content, .file-content {
    width: 100%;
    height: 100%;
    canvas {
      width: 100% !important;
    }

    ::v-deep canvas {
      width: 100% !important;
    }

    ::v-deep {
      canvas {
        width: 100% !important;
      }
    }
  }
}
</style>